import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { CloseIcon, StarIcon } from "../../icons";
import useAnalytics from "../../../hooks/useAnalytics";
import style from "./styles.module.css";

const NO_OF_STARS = 5;

function Survey({ open, surveyQuestion, onModalChange }) {
  const { captureEvent } = useAnalytics();

  const [rating, setRating] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setRating(0);
    setIsModalOpen(open);
  }, [open]);

  const handleClick = (index) => {
    setRating(NO_OF_STARS - index);
  };

  const handleSubmit = () => {
    captureEvent("Survey", { rating });
    onModalChange(false);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    onModalChange(false);
  };

  return (
    <div
      className={`${style.survey} ${
        isModalOpen ? style.surveyOpen : style.surveyClose
      }`}
    >
      <div className={style.backdrop} />

      <div className={style.modal}>
        <button className={style.closeModal} onClick={handleClose}>
          <CloseIcon size={30} />
        </button>
        <h1 className={style.modalTitle}>{surveyQuestion}</h1>

        <div className={style.starRating}>
          {Array.from({ length: NO_OF_STARS }, (_, index) => (
            <StarIcon
              key={index}
              onClick={() => handleClick(index)}
              isActive={NO_OF_STARS - index <= rating}
            />
          ))}
        </div>

        <button
          disabled={rating < 1}
          onClick={handleSubmit}
          className={style.surveyButton}
        >
          Send
        </button>
      </div>
    </div>
  );
}

const SurveyPortal = (props) => {
  return createPortal(<Survey {...props} />, document.body);
};

export default SurveyPortal;
